import Footer from "../footer/Footer";
import { Helmet } from "react-helmet";
import { Trans, useTranslation } from 'react-i18next'
import { Link } from "react-router-dom";
import history from "../../assets/project-history.png";
import current from "../../assets/current-history.png";
import future from "../../assets/future-projects.png";

import Card from "./Card"
import "./Pages.css";
const Projects = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="projects">
        <Helmet>
          <title>
            Esnad e.V | Projects| Projekte
          </title>
        </Helmet>
        <div className="cards">
          <table>
            <tr>
              <td>
                <Link to={"history"} style={{ textDecoration: "none" }}>
                  <img
                    class="rel"
                    width={110}
                    height={110}
                    src={history}
                    alt="ESNAD e.V"
                  />
                </Link>
              </td>
              <td>
                <Link to={"current"} style={{ textDecoration: "none" }}>
                <img
                    class="rel"
                    width={120}
                    height={120}
                    src={current}
                    alt="ESNAD e.V"
                  />
                </Link>
              </td>
              <td>
                <Link to={"plan"} style={{ textDecoration: "none" }}>
                <img
                    class="rel"
                    width={120}
                    height={120}
                    src={future}
                    alt="ESNAD e.V"
                  />
                </Link>
              </td>
            </tr>
            <tr>
              <td>
                <Link to={"history"} style={{ textDecoration: "none" , color: "black"}}>
                {t("Projects-History")}
                </Link>
              </td>
              <td>
                <Link to={"current"} style={{color:"black", textDecoration:"none"}}>
                  {t("Current-Projects")}
                </Link>
              </td>
              <td>
                <Link to={"plan"} style={{color:"black", textDecoration:"none"}}>
                  {t("Year-Plan")}
                </Link>
              </td>
            </tr>
          </table>

           {/*<Card key={0} text={t("Projects-History")} to={"history"} index={0} />
           <Card key={1} text={t("Current-Projects")} to={"current"} index={1} />
           <Card key={2} text={t("Year-Plan")} to={"plan"} index={2} />*/}
        </div>
        <Trans i18nKey="Project-Content" components={{ p: <p/> , pre: <pre/>, h2: <h2/>, h4: <h4/>, ul: <ul/>, li: <li/>, strong: <strong/>, h5: <h5/>}} />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Projects;
